module.exports = function (data) {

    if (data.product && data.product.Stockcode) {
        data.event = 'BWSAUkeywordProductSearch';
    } else if (data.category && data.category.Name) {
        data.event = 'BWSAUkeywordCategorySearch';
    } else if (data.store && data.store.StoreId) {
        data.event = 'BWSAUkeywordStoreSearch';
    } else if (data.filters) {
        data.event = 'BWSAUfilterResult';
    } else {
        data.event = 'BWSAUkeywordSearch';
    }

    const event = {
        event: data.event,
        eventContext: {
            area: data.area,
            searchKeyword: data.keyword,
            searchResultsCount: data.searchCount,
            searchType: data.searchType || '',
            searchStore: data.store || '',
            searchCategory: data.category || '',
            productInfo: data.product,
            filters: data.filters || '',
            eventID: data.eventId
        }
    };

    return event;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/atm/search-mapper.js
 **/